import React from 'react';
import '../styles/VideoPage.css';
import '../styles/TeamPage.css';

function Team() {
  const teamMembers = [
    {
      id: 1,
      name: "राज शर्मा",
      position: "मुख्य संपादक",
      image: "https://via.placeholder.com/200x200?text=Team+1"
    },
    {
      id: 2,
      name: "प्रिया वर्मा",
      position: "वरिष्ठ पत्रकार",
      image: "https://via.placeholder.com/200x200?text=Team+2"
    },
    {
      id: 3,
      name: "अमित मिश्रा",
      position: "प्रौद्योगिकी संपादक",
      image: "https://via.placeholder.com/200x200?text=Team+3"
    },
    {
      id: 4,
      name: "निशा सिंह",
      position: "समाचार संवाददाता",
      image: "https://via.placeholder.com/200x200?text=Team+4"
    }
  ];

  return (
    <div className="info-page">
      <div className="info-container team-container">
        <div className="info-header">
          <h1>👥 हमारी टीम</h1>
        </div>
        <div className="info-content">
          <div className="team-grid">
            {teamMembers.map(member => (
              <div key={member.id} className="team-card">
                <img src={member.image} alt={member.name} />
                <h3>{member.name}</h3>
                <p>{member.position}</p>
              </div>
            ))}
          </div>

          <div className="info-section">
            <h2>हमारी संरचना</h2>
            <p>
              लत्थ सा-ब न्यूज़ की टीम अनुभवी पत्रकारों, वीडियोग्राफ़रों और तकनीकी विशेषज्ञों से बनी है। हर सदस्य अपने क्षेत्र में माहिर है और चित्रकूट के विकास के लिए समर्पित है।
            </p>
          </div>

          <div className="info-section">
            <h2>हमारी सेवाएं</h2>
            <ul className="info-list">
              <li>दैनिक समाचार रिपोर्टिंग</li>
              <li>विशेष जांच पत्रकारिता</li>
              <li>वीडियो समाचार सेवा</li>
              <li>सोशल मीडिया पर तुरंत अपडेट</li>
              <li>सामुदायिक गतिविधियों का कवरेज</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Team;
